import { Editor } from 'slate';

import { TableElement, TableEntry } from '../types';

export const getTableById = (editor: any, id: string): TableEntry =>
  Array.from(
    Editor.nodes(editor, {
      at: [],
      match: (node: any) => node.type === TableElement.TABLE && node.id === id,
    })
  )?.[0] as TableEntry;
